import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Table } from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ScrambleText from "../utils/ScrambleText";
const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CsAndItTable7 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const ageGroups = data.map((item) => item.age_group_label);
  const growthRates = data.map((item) => parseFloat(item.growth_rate));

  // const chartData = {
  //   labels: ageGroups,
  //   datasets: [
  //     {
  //       label: "Employment Growth (%)",
  //       data: growthRates,
  //       backgroundColor: growthRates.map((rate) =>
  //         rate >= 0 ? "#0142B2" : "#CB0C0C"
  //       ), // Blue for positive, Red for negative
  //       borderColor: growthRates.map((rate) =>
  //         rate >= 0 ? "#0142B2" : "#CB0C0C"
  //       ),
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  const positiveRates = data.map((item) =>
    parseFloat(item.growth_rate) >= 0 ? parseFloat(item.growth_rate) : null
  );
  const negativeRates = data.map((item) =>
    parseFloat(item.growth_rate) < 0 ? parseFloat(item.growth_rate) : null
  );

  const chartData = {
    labels: ageGroups,
    datasets: [
      {
        label: "Positive Growth",
        data: positiveRates,
        backgroundColor: "#0142B2", // blue
        borderColor: "#0142B2",
        borderWidth: 1,
      },
      {
        label: "Negative Growth",
        data: negativeRates,
        backgroundColor: "#CB0C0C", // red
        borderColor: "#CB0C0C",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true, // Hides legend since we have only one dataset
      },
      title: {
        display: true,
        text: "Employment Growth (%) by Age Group (2018-2024)",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Age Group",
        },
      },
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: "Growth Percentage (%)",
        },
        ticks: {
          callback: function (value) {
            return value + "%"; // Adds % sign to Y-axis
          },
        },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;

    const originalWidth = input.style.width;
    input.style.width = "1100px";
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(utahData, "PNG", 60, 4, 30, 30);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);

      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString();
      pdf.setFontSize(12);
      pdf.text(`Downloaded on: ${formattedDate}`, 150, 295);

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.line(10, 35, 200, 35);

      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.line(10, 260, 200, 260);

      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 33, footerStartY, 20, 20);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);

      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);

      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("csAndIt_table7.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <div className="dashboard-container">
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Employment Growth (%) by Age Group (2018-2024)</h2>

          {/* Render Table */}
          <div style={{ overflowX: "auto", marginBottom: "20px" }}>
            <Table
              border="1"
              cellPadding="10"
              style={{ width: "100%", minWidth: "400px", background: "#fff" }}
            >
              <thead>
                <tr>
                  <th>Age Group</th>
                  <th>2018</th>
                  <th>2019</th>
                  <th>2020</th>
                  <th>2021</th>
                  <th>2022</th>
                  <th>2023</th>
                  <th>2024</th>
                  <th>Growth Rate (%)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{row.age_group_label}</td>
                    <td>{row.y2018}</td>
                    <td>{row.y2019}</td>
                    <td>{row.y2020}</td>
                    <td>{row.y2021}</td>
                    <td>{row.y2022}</td>
                    <td>{row.y2023}</td>
                    <td>{row.y2024}</td>
                    {/* <td>{row.age_group_label}</td> */}
                    <td
                      style={{
                        color: row.growth_rate >= 0 ? "#0142B2" : "#CB0C0C",
                        fontWeight: "bold",
                      }}
                    >
                      {row.growth_rate}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Bar Chart */}
          <div
            style={{
              width: "90%",
              maxWidth: "800px",
              margin: "auto",
              overflowX: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                minWidth: "600px",
                height: "400px",
                background: "#fff",
              }}
            >
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} onClick={downloadPDF} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default CsAndItTable7;
